import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import CustomDropdown from "../../../../components/Select/CustomDropdown";
import { toast } from "react-hot-toast";
import HelperService from '../../../../utility/HelperService';
import { CgClose } from 'react-icons/cg';
import CircularProgressbar from '../../../../screens/DataEntryOperator/Dashboard/AssetAllocation/CircularProgressbar';

const CircularProgressbarDisplay = (props: any) => {
    var futuar_total = 0;
    return (<>
        <Transition.Root show={props.pIChartPopup} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={props.cancelButtonRef} onClose={props.setPIChartPopup}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[1200px] sm:p-6">
                                <div className="mb-3">
                                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900 flex justify-center">
                                            <h2 className='text-xl'> {props.goalName}   </h2>
                                            <a href="javascript:void(0)" className='absolute right-[24px]' onClick={() => props.setPIChartPopup(false)}> {/*<CgClose size={22} /> */}</a>
                                        </Dialog.Title>
                                        <div className=" grid grid-cols-4 gap-4 form-style mt-1">
                                            {props.riskProfile &&
                                                props.riskProfile.map((res: any, index: number) => {

                                                    return (
                                                        <span className=''><b>Risk Profile : </b>{res.risk_rating} </span>
                                                    );
                                                })}
                                            <div><b>Maturity Amount : </b> {(props.goal_maturity_required>0)?HelperService.getCurrencyFormatterWithoutDecimal(props.goal_maturity_required):'NA'}</div>
                                            <div><b>Maturity Date : </b> {HelperService.getFormatedDateByDMY(props.goalMaturityDate)}</div>
                                            {/* <p className='text-sm  text-gray-500 font-normal'>{HelperService.getFormatedDateByDMY(props.goalMaturityDate)}</p> */}
                                            <div><b>Tenure : </b>{props.selfTenure ?  HelperService.getCurrencyFormatter(props.selfTenure) :'0'} Years ({props.goalNature}) </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="border-b max-h-[200px] overflow-auto">
                                        <table className='table-style-list table-striped table-border'>
                                            <thead className='sticky top-0'>
                                                <tr>
                                                    <th>Asset Earmarked</th>
                                                    <th> Earmarked %</th>
                                                    <th className='amount'>Current Value ₹</th>
                                                    <th className='amount'>Future Value ₹</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.assetEarmarkedList.length > 0 && props.assetEarmarkedList.map((res: any, index: any) => {
                                                    futuar_total = futuar_total + parseFloat(res.maturity_amount);

                                                    return (
                                                        <tr>
                                                            <td className=''>{res.asset_name}</td>
                                                            <td className='amount'>{HelperService.getCurrencyFormatter(res.percent_mapping)}%</td>
                                                            <td className='amount'>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.current_valuation)}</td>
                                                            <td className='amount'>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.maturity_amount)}</td>
                                                        </tr>
                                                    );
                                                })}

                                                {props.assetEarmarkedList.length > 0 &&

                                                    <tr>
                                                        <td className='font-bold' style={{ 'textAlign': 'right' }} colSpan={3}>Total</td>
                                                        <td className='amount font-bold'>₹{(futuar_total>props.goal_maturity_required)?HelperService.getCurrencyFormatterWithoutDecimal(futuar_total):HelperService.getCurrencyFormatterWithoutDecimal(futuar_total)}</td>                                                    </tr>

                                                }
                                                {props.assetEarmarkedList.length == 0 &&
                                                    <tr>
                                                        <td colSpan={0}>No records fund</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* <div className='flex flex-wrap justify-center items-center gap-3 mt-4'>
                                            <p className='mr-3'><BsCircleFill size={16} className=' text-[#0066FF]' /> Debt</p>
                                            <p className='mr-3'><BsCircleFill size={16} className='  text-[#FF8A00]' /> Equity</p>
                                            <p className='mr-3'><BsCircleFill size={16} className='  text-[#D7565E]' /> Bullion</p>
                                            <p><BsCircleFill size={16} className='  text-[#1C1F3E]' /> Real Estate</p>
                                            <p><BsCircleFill size={16} className='  text-[#B556D7]' /> International Equity</p>
                                        </div> */}
                                    <div className="grid grid-cols-6">
                                        <div className='col-span-2'>
                                            <h4 className='font-semibold mt-3 text-center'>Asset allocation - <span className=' text-gray-600'>Desired</span> </h4>
                                            <div className="circular-progress-bar-div mt-5">
                                                <CircularProgressbar
                                                    data={props.doughnutData}
                                                    backgroundColor={props.doughnutBackgroundColorData}
                                                    labels={props.doughnutLabelData}
                                                    // height={5}
                                                    // width={5}
                                                    cutoutPercentage={0}

                                                />
                                            </div>
                                        </div>
                                        <div className='col-span-2'></div>
                                        <div className='col-span-2'>
                                            <h4 className='font-semibold mt-3 text-center'>Asset allocation - <span className=' text-gray-600'>Current valuation wise</span> </h4>
                                            <div className="circular-progress-bar-div mt-5">
                                                {/* <p className='mb-3 text-sm'>Current valuation wise</p> */}
                                                <CircularProgressbar
                                                    data={props.doughnutData2}
                                                    backgroundColor={props.doughnutBackgroundColorData2}
                                                    labels={props.doughnutLabelData2}
                                                    // height={5}
                                                    // width={5}
                                                    cutoutPercentage={0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:w-auto"
                                            onClick={() => setOpen(false)}
                                        >
                                            Deactivate
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
                                            onClick={() => setOpen(false)}
                                            ref={cancelButtonRef}
                                        >
                                            Cancel
                                        </button>
                                    </div> */}
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className="btn btn-brand-light mr-5"
                                        onClick={() => props.setPIChartPopup(false)}
                                        ref={props.cancelButtonRef}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    </>);
};
export default CircularProgressbarDisplay;
